import React from 'react';
import Typography from 'design-system/src/Components/Typography/Typography.web';
import SocialNetworkAuthentication from '../../../../SocialNetworkAuthentication/SocialNetworkAuthentication';
import TextInputController from 'design-system/src/Components/Form/TextInputController/TextInputController';
import Metrics from 'design-system/src/Theme/Metrics';
import Button from 'design-system/src/Components/Button/Button';
import styled from 'styled-components';
import {getAllowedAuthProviders} from '@src/Configs/authDomainConfig';

const FormContainer = styled.div`
  width: 100%;
  max-width: 434px;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

interface SignupEmailFormContentProps {
  control: any;
  isMobile: boolean;
  t: (key: string) => string;
  handleFormSubmit: () => void;
}

const SignupEmailFormContent: React.FC<SignupEmailFormContentProps> = ({
  control,
  isMobile,
  t,
  handleFormSubmit,
}) => {
  const allowedProviders = getAllowedAuthProviders();
  const showEmailAuth = allowedProviders.includes('email');

  return (
    <FormContainer>
      <Typography
        variant={isMobile ? 'body2' : 'formTitle'}
        style={{
          textTransform: 'uppercase',
          marginBottom: 25,
        }}>
        {t('Sign up')}
      </Typography>
      <SocialNetworkAuthentication />
      {showEmailAuth && (
        <>
          <Typography variant="body2" style={{marginBottom: 25, marginTop: 25}}>
            {t('Or')}
          </Typography>

          <TextInputController
            control={control}
            name="email"
            defaultValue=""
            label={t('Email') + ''}
            rules={{
              required: t('Email is required') + '',
            }}
            placeholder={t('your@email.com') || ''}
            style={{marginBottom: Metrics.verticalScale(32)}}
            variant="transparent"
          />

          <Button
            variant="contained"
            size="small"
            title={t('Register')}
            fullWidth
            onPress={handleFormSubmit}
          />
        </>
      )}
    </FormContainer>
  );
};

export default SignupEmailFormContent;